import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
export const Section = React.forwardRef(({ padding = 'regular', edgeToEdge, hideOverflow, className, ...props }, ref) => (_jsx("div", { className: clsx(hideOverflow && 'overflow-x-hidden'), children: _jsx("section", { ref: ref, className: clsx(!edgeToEdge && 'mx-auto w-full max-w-360 px-6 md:px-10 xl:px-25', 'py-10', padding === 'small' ? 'md:py-10' : 'md:py-20', className), ...props }) })));
Section.displayName = 'Section';
